import styles from 'components/RteEditor/RteEditor.module.css';

export const UvaTheme = {
  ltr: styles['guide-text-ltr'],
  rtl: styles['guide-text-rtl'],
  paragraph: styles['guide-text-paragraph'],
  text: {
    bold: styles['guide-text__text--bold'],
    italic: styles['guide-text__text--italic'],
  },
  list: {
    listitem: styles['guide-text__list--listitem'],
    nested: {
      listitem: styles['guide-text__list--nested-listitem'],
    },
    olDepth: [
      styles['guide-text__list--ol'],
      styles['guide-text__list--ol2'],
      styles['guide-text__list--ol3'],
      styles['guide-text__list--ol4'],
      styles['guide-text__list--ol5'],
    ],
    ulDepth: [
      styles['guide-text__list--ul'],
      styles['guide-text__list--ul2'],
      styles['guide-text__list--ul3'],
      styles['guide-text__list--ul4'],
      styles['guide-text__list--ul5'],
    ],
    ul: styles['guide-text__list--ul'],
  },
  link: styles['guide-text__link'],
  table: styles['guide-text__table'],
};
